module.exports = __webpack_public_path__ + "static/media/profile.11d9c2fc.png";